import React from 'react'
import { NavLink, useLocation } from 'react-router-dom'
import './style.scss'
import { IsPathActive } from '../../utils/helpers'

const Search = () => {
    const { pathname } = useLocation()
    const linkClass = ({ isActive }) => isActive ? 'btn shadow-sm isActive' : 'btn shadow-sm'
    const rootActive = IsPathActive(pathname, '/search/')

    return (
        <div className="custom-navbar">
            <div className="container">
                <div className="row">
                    <div className="col-12 text-center">
                        <NavLink
                            className={`btn shadow-sm ${rootActive ? 'isActive' : ''}`}
                            to="/search/"
                        >basic</NavLink>
                        <NavLink
                            className={linkClass}
                            to="/search/advance"
                        >advance</NavLink>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Search;
